import Axios from 'axios';
import { CDN_BASE_URL } from 'settings';

export const fetchMaintenceMessage = () => {
  return Axios.get(`${CDN_BASE_URL}/maintenance-message.json`).then((response) => response.data?.message);
};
